var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBriefcase({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#briefcase_svg__clip0_1161_2219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.208 4.082H12.33V2.519c0-.744-.606-1.35-1.35-1.35H7.02c-.744 0-1.35.606-1.35 1.35v1.563H1.792C.804 4.082 0 4.886 0 5.874v9.165c0 .988.804 1.792 1.792 1.792h14.416c.988 0 1.792-.804 1.792-1.792V5.874c0-.988-.804-1.792-1.792-1.792zM6.814 2.519c0-.114.092-.206.206-.206h3.96c.114 0 .206.092.206.206v1.563H6.814V2.519zm-5.67 3.355a.65.65 0 01.648-.649h14.416a.65.65 0 01.649.649v.846c0 .793-.532 1.502-1.294 1.724l-5.978 1.74a2.089 2.089 0 01-1.17 0l-5.978-1.74A1.805 1.805 0 011.143 6.72v-.846zm15.064 9.813H1.792a.65.65 0 01-.649-.648V9.047c.288.223.616.39.974.495 6.604 1.922 6.265 1.87 6.883 1.87.627 0 .271.054 6.883-1.87.358-.105.686-.272.974-.495v5.992a.65.65 0 01-.649.649z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "briefcase_svg__clip0_1161_2219"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h18v18H0z"
  })))));
}

export default SvgBriefcase;